import { FC } from 'react'

interface Props {
	canvasData: number[]
}

export const CarrierOneConditioningCanvas: FC<Props> = ({
	canvasData
}) => {
	const dataMapFill = (data: number, reversed?: boolean) => {
		switch (canvasData[data]) {
			case 0:
				return reversed ? '#A0E768' : '#C9D4E9'
			case 1:
				return reversed ? '#C9D4E9' : '#A0E768'
			default:
				return reversed ? '#A0E768' : '#C9D4E9'
		}
	}

	const dataMapStroke = (data: number, reversed?: boolean) => {
		switch (canvasData[data]) {
			case 0:
				return reversed ? '#7AB050' : '#9CB4DB'
			case 1:
				return reversed ? '#9CB4DB' : '#7AB050'
			default:
				return reversed ? '#7AB050' : '#9CB4DB'
		}
	}

	const renderStatusRect = (
		index: number,
		x: number,
		y: number,
		width: number,
		height: number,
		reversed?: boolean
	) => {
		if (reversed) {
			return (
				<g key={`status-${index}`}>
					<rect
						x={x}
						y={y}
						width={width}
						height={height}
						rx="3.5"
						strokeWidth="1"
						fill={dataMapFill(index, true)}
						stroke={dataMapStroke(index, true)}
					/>
					<line
						x1={x}
						y1={y + height}
						x2={x + width}
						y2={y}
						stroke="#9CB4DB"
						strokeWidth="1"
					/>
				</g>
			)
		}
		return (
			<rect
				key={`status-${index}`}
				x={x}
				y={y}
				width={width}
				height={height}
				rx="3.5"
				fill={dataMapFill(index)}
				stroke={dataMapStroke(index)}
			/>
		)
	}

	return (
		<svg
			width="746"
			height="130"
			viewBox="0 0 746 130"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect width="746" height="130" rx="6" fill="#F2F4F8" />
			<path d="M0 45H673" stroke="#C1CCDE" strokeWidth="2" />
			<path d="M143 105H225" stroke="#C1CCDE" strokeWidth="2" />
			<path
				d="M143 106L143 45"
				stroke="#C1CCDE"
				strokeWidth="2"
			/>
			<path
				d="M225 106L225 45"
				stroke="#C1CCDE"
				strokeWidth="2"
			/>
			<text
				x="26"
				y="22"
				fill="#142D49"
				fontSize={10}
				fontWeight={500}>
				УПРАВЛЕНИЕ
			</text>
			<text
				x="140"
				y="22"
				fill="#142D49"
				fontSize={10}
				fontWeight={500}>
				КНП. ВКЛ. ПР. ВЕНТ
			</text>
			<text
				x="260"
				y="22"
				fill="#142D49"
				fontSize={10}
				fontWeight={500}>
				КОНТАКТОР ПР. ВЕРТ
			</text>
			<text
				x="390"
				y="22"
				fill="#142D49"
				fontSize={10}
				fontWeight={500}>
				ТЕРМОДАТЧИК ПР.
			</text>
			<text
				x="520"
				y="22"
				fill="#142D49"
				fontSize={10}
				fontWeight={500}>
				АВАРИЯ 1 КАНАЛ
			</text>
			<text
				x="640"
				y="22"
				fill="#142D49"
				fontSize={10}
				fontWeight={500}>
				ПРИТОЧНЫЙ ВЕНТ.
			</text>
			<text
				x="152"
				y="83"
				fill="#142D49"
				fontSize={10}
				fontWeight={500}>
				ВЕНТИЛЯТОР
			</text>
			{renderStatusRect(0, 43.5, 30.5, 29, 29)}
			{renderStatusRect(1, 169.5, 30.5, 29, 29)}
			{renderStatusRect(2, 169.5, 90.5, 29, 29)}
			{renderStatusRect(3, 295.5, 30.5, 29, 29)}
			{renderStatusRect(4, 421.5, 30.5, 29, 29)}
			{renderStatusRect(5, 547.5, 30.5, 29, 29, true)}
			<rect
				x="673.5"
				y="30.5"
				width="29"
				height="29"
				rx="3.5"
				stroke="#9CB4DB"
			/>
			{renderStatusRect(6, 677.5, 34.5, 21, 21)}
		</svg>
	)
}
